/* eslint-disable react-refresh/only-export-components */
import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import './index.css';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { BrowserRouter } from 'react-router-dom';
import { ThemeModeProvider, useThemeMode } from './context/ThemeContext.jsx';
import getDesignTokens from './utils/theme'; // Ensure this path is correct

// Dynamically apply theme based on the current mode
const DynamicThemeProvider = ({ children }) => {
  const { mode } = useThemeMode(); // This hook must be used inside a component that is a child of ThemeModeProvider
  const theme = React.useMemo(() => createTheme(getDesignTokens(mode)), [mode]);

  return (
    <ThemeProvider theme={theme}>
      {children}
    </ThemeProvider>
  );
};

ReactDOM.createRoot(document.getElementById('root')).render(
  <StrictMode>
    <ThemeModeProvider>
      <DynamicThemeProvider>
        <CssBaseline />
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </DynamicThemeProvider>
    </ThemeModeProvider>
  </StrictMode>
);
